import { AuthenticationTypes } from '../AuthenticateDialog.types';

export const DISPLAYED_TYPES: AuthenticationTypes[] = [AuthenticationTypes.SignIn, AuthenticationTypes.Register];
